/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproversResponse
 */
export interface ApproversResponse {
    /**
     * The user id of the approver user
     * @type {string}
     * @memberof ApproversResponse
     */
    user_id: string;
    /**
     * The email of the approver user
     * @type {string}
     * @memberof ApproversResponse
     */
    email: string;
}

export function ApproversResponseFromJSON(json: any): ApproversResponse {
    return ApproversResponseFromJSONTyped(json, false);
}

export function ApproversResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproversResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'email': json['email'],
    };
}

export function ApproversResponseToJSON(value?: ApproversResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'email': value.email,
    };
}


